import * as actionTypes from '../types/so';

const initialState = {
  listSO: [],
  soRP: [],
  defaultCheckedRPKeys: [],
  error: false,
  loadingRP: false,
  loadingSO: false,
  loadingRebind: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_SO:
    case actionTypes.GET_SO_FOR_REBIND:
      return {
        ...state,
        loadingSO: true
      };
    case actionTypes.GET_SO_SUCCESS:
    case actionTypes.GET_SO_FOR_REBIND_SUCCESS:
      return {
        ...state,
        listSO: payload,
        soRP: [],
        loadingSO: false
      };
    case actionTypes.GET_SO_FAIL:
    case actionTypes.GET_SO_FOR_REBIND_FAIL:
      return {
        ...state,
        loadingSO: false
      };
    case actionTypes.GET_SO_RP:
      return {
        ...state,
        loadingRP: true
      };
    case actionTypes.GET_SO_RP_SUCCESS:
      return {
        ...state,
        soRP: payload,
        defaultCheckedRPKeys: payload
          .filter((item) => item.checkbox !== 'NOT_SELECTED')
          .map(({ pieceNumId }) => pieceNumId),
        loadingRP: false
      };
    case actionTypes.GET_SO_RP_FAIL:
      return {
        ...state,
        soRP: [],
        loadingRP: false
      };
    case actionTypes.REBIND_SO_RP:
      return {
        ...state,
        loadingRebind: true
      };
    case actionTypes.REBIND_SO_RP_SUCCESS:
      return {
        ...state,
        loadingRebind: false
      };
    case actionTypes.REBIND_SO_RP_FAIL:
      return {
        ...state,
        loadingRebind: false
      };
    default:
      return state;
  }
};

export default reducer;
